import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";

import Image from "../image";
import IconArrow from "../icons/arrow";
import { useRef } from "react";

SwiperCore.use([Navigation]);

export default function SwiperWrapper(props) {
    const { images, autoHeight, arrowsBottom, pagination, aspectRatio } = props;

    const prevRef = useRef(null);
    const nextRef = useRef(null);

    return (
        <Swiper
            navigation={{
                prevEl: prevRef.current ? prevRef.current : undefined,
                nextEl: nextRef.current ? nextRef.current : undefined,
            }}
            onInit={(swiper) => {
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.params.navigation.nextEl = nextRef.current;
                swiper.navigation.update();
            }}
            autoHeight={autoHeight}
            centeredSlides={true}
            slidesPerView={1}
            loop={false}
            pagination={pagination}
        >
            {images.map((item, i) => (
                <SwiperSlide key={`slide_${i}`}>
                    <div className={arrowsBottom ? "" : "xl:mx-60"}>
                        {autoHeight && (
                            <img
                                alt={item.alt || item.caption}
                                title={item.caption}
                                className="w-full"
                                src={item.url + "?w=1024"}
                            />
                        )}
                        {!autoHeight && (
                            <Image
                                alt={item.alt || item.caption}
                                url={item.url}
                                aspectRatio={aspectRatio}
                            />
                        )}
                        {item.caption && (
                            <p className="text-left mt-16">{item.caption}</p>
                        )}
                    </div>
                </SwiperSlide>
            ))}
            {images.length > 1 && arrowsBottom && (
                <div className="hidden xl:flex justify-end relative -mr-16">
                    <div ref={prevRef} className="cursor-pointer p-16">
                        <IconArrow className="transform -rotate-90 h-26 w-26" />
                    </div>
                    <div ref={nextRef} className="cursor-pointer p-16">
                        <IconArrow className="transform rotate-90 h-26 w-26" />
                    </div>
                </div>
            )}
            {images.length > 1 && !arrowsBottom && (
                <div className="hidden xl:flex absolute top-0 bottom-0 left-0 right-0 z-50 items-center">
                    <div className="flex flex-row justify-between w-full">
                        <div ref={prevRef} className="cursor-pointer">
                            <IconArrow className="transform -rotate-90 h-26 w-26" />
                        </div>
                        <div ref={nextRef} className="cursor-pointer">
                            <IconArrow className="transform rotate-90 h-26 w-26" />
                        </div>
                    </div>
                </div>
            )}
        </Swiper>
    );
}
